(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('alp-countdown')) {
    customElements.define(
      'alp-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.end = Date.parse(this.dataset.end);
          this.out = this.querySelector('[data-time]');
          if (Number.isNaN(this.end) || !this.out) return;
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
          if (left === 0) {
            clearInterval(this.timer);
            const slide = this.closest('.announcement-countdown');
            const bar = this.closest('.announcement-bar');
            if (slide) slide.hidden = true;
            if (bar && !bar.querySelector('.announcement-bar__slide:not([hidden])')) {
              const section = bar.closest('.shopify-section');
              (section || bar).hidden = true;
            }
            return;
          }
          const pad = (n) => String(n).padStart(2, '0');
          const d = Math.floor(left / 86400);
          const h = Math.floor((left % 86400) / 3600);
          const m = Math.floor((left % 3600) / 60);
          const s = left % 60;
          this.out.textContent = `${d > 0 ? d + 'T ' : ''}${pad(h)}:${pad(m)}:${pad(s)}`;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
